var map = {
	"./af-ZA.svg": 5977,
	"./ar-EG.svg": 2676,
	"./bg.svg": 8232,
	"./cs.svg": 9796,
	"./de-AT.svg": 4681,
	"./de-CH.svg": 705,
	"./de.svg": 1800,
	"./el.svg": 2884,
	"./en-AU.svg": 297,
	"./en-NZ.svg": 1536,
	"./en-US.svg": 367,
	"./en.svg": 668,
	"./es-AR.svg": 9050,
	"./es-PR.svg": 960,
	"./es.svg": 6682,
	"./et.svg": 7828,
	"./fi.svg": 4924,
	"./fil-PH.svg": 6144,
	"./fr-BE.svg": 6629,
	"./fr-CH.svg": 3447,
	"./fr.svg": 7347,
	"./he-IL.svg": 4986,
	"./hu.svg": 1487,
	"./it.svg": 6008,
	"./lt.svg": 4575,
	"./lv.svg": 146,
	"./nl.svg": 8083,
	"./pl.svg": 7106,
	"./pt.svg": 2623,
	"./ro.svg": 5181,
	"./ru.svg": 2244,
	"./sk.svg": 3933,
	"./sr.svg": 1664,
	"assets/images/flags/af-ZA.svg": 5977,
	"assets/images/flags/ar-EG.svg": 2676,
	"assets/images/flags/bg.svg": 8232,
	"assets/images/flags/cs.svg": 9796,
	"assets/images/flags/de-AT.svg": 4681,
	"assets/images/flags/de-CH.svg": 705,
	"assets/images/flags/de.svg": 1800,
	"assets/images/flags/el.svg": 2884,
	"assets/images/flags/en-AU.svg": 297,
	"assets/images/flags/en-NZ.svg": 1536,
	"assets/images/flags/en-US.svg": 367,
	"assets/images/flags/en.svg": 668,
	"assets/images/flags/es-AR.svg": 9050,
	"assets/images/flags/es-PR.svg": 960,
	"assets/images/flags/es.svg": 6682,
	"assets/images/flags/et.svg": 7828,
	"assets/images/flags/fi.svg": 4924,
	"assets/images/flags/fil-PH.svg": 6144,
	"assets/images/flags/fr-BE.svg": 6629,
	"assets/images/flags/fr-CH.svg": 3447,
	"assets/images/flags/fr.svg": 7347,
	"assets/images/flags/he-IL.svg": 4986,
	"assets/images/flags/hu.svg": 1487,
	"assets/images/flags/it.svg": 6008,
	"assets/images/flags/lt.svg": 4575,
	"assets/images/flags/lv.svg": 146,
	"assets/images/flags/nl.svg": 8083,
	"assets/images/flags/pl.svg": 7106,
	"assets/images/flags/pt.svg": 2623,
	"assets/images/flags/ro.svg": 5181,
	"assets/images/flags/ru.svg": 2244,
	"assets/images/flags/sk.svg": 3933,
	"assets/images/flags/sr.svg": 1664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2077;